import { cacheSession } from "@/utils/common";

const app = {
  state: {
    DepartmentId: 0,
    DepartmentName: "",
    DoctorId: 0,
    DoctorName: "",
    SourceId: "",
    TimePeriodType: 0,
    WorkTimeStar: "",
    WorkTimeEnd: "",
    TreatmentDate: ""
  },
  mutations: {
    SET_DEPARTMENT: (state, order) => {
      state.DepartmentId = order.id ? order.id : 0;
      state.DepartmentName = order.text;
    },
    SET_DOCTOR: (state, data) => {
      state.DoctorId = data.id ? data.id : 0;
      state.DoctorName = data.name;
    },
    SET_ORDER: (state, order) => {
      if (order) {
        for (const key in order) {
          const value = order[key];
          state[key] = value;
        }
      }
    },
    SET_SOURCENUM(state, data) {
      state.SourceId = data.id;
      state.TimePeriodType = data.timePeriodType;
      state.WorkTimeStar = data.workTimeStart;
      state.WorkTimeEnd = data.workTimeEnd;
      state.TreatmentDate = data.treatmentDate;
    }
  },
  actions: {
    setDepartment({ commit }, order) {
      commit("SET_DEPARTMENT", order);
      this.dispatch("cacheOrder");
    },
    setDoctor({ commit }, data) {
      commit("SET_DOCTOR", data);
      this.dispatch("cacheOrder");
    },
    //设置号源数据
    setSourceNum({ commit }, data) {
      commit("SET_SOURCENUM", data);
      this.dispatch("cacheOrder");
    },
    cacheOrder() {
      cacheSession.set("order", this.state.order);
    },
    setOrder({ commit }, order) {
      commit("SET_ORDER", order);
    }
  }
};

export default app;
